import {
	Box,
	Button,
	Card,
	CardActions,
	CardContent,
	Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormType } from '@/api/enum/formType.enum';
import { useRef, useState } from 'react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EditCaseStatusForm from './components/EditCaseStatusForm';
import { useNavigate, useParams } from 'react-router-dom';
import {
	useEditPreAdmissionMutation,
	useGetPreAdmissionDetailQuery,
} from '@/api/pre-admission/preAdmission';
import { closeSnackbar, enqueueSnackbar } from 'notistack';
import CloseIcon from '@mui/icons-material/Close';

export default function EditCaseStatusPage() {
	const { t } = useTranslation();
	const [type, setType] = useState<FormType>(FormType.edit);
	const navigate = useNavigate();
	const { preAdmissionId } = useParams();
	const [editPreAdmission] = useEditPreAdmissionMutation();

	const { data: details }: any = useGetPreAdmissionDetailQuery(
		preAdmissionId || '',
		{
			refetchOnMountOrArgChange: true,
		}
	);

	const caseStatusRef = useRef<{
		getFormData: () => Promise<any>;
		validateForm: () => Promise<boolean>;
	}>(null);

	const handleSubmit = async () => {
		const results = await Promise.all([
			caseStatusRef.current?.validateForm() || Promise.resolve(false),
		]);

		if (results.some((result) => result === false)) return;

		const formData = {
			...((await caseStatusRef.current?.getFormData()) || {}),
		};

		const response = await editPreAdmission({
			...formData,
			type: 3,
		});
		if ('data' in response) {
			enqueueSnackbar(t('snackbar.updatePreAdmissionSuccess'), {
				variant: 'success',
				anchorOrigin: { horizontal: 'center', vertical: 'top' },
				autoHideDuration: 3000,
				action: (key) => {
					return <CloseIcon onClick={() => closeSnackbar(key)} />;
				},
			});
			navigate(`/pre-admission/pre-admission-list/detail/${preAdmissionId}`);
		}
	};

	return (
		<>
			<Box sx={{ width: '100%' }}>
				<Box>
					<Typography variant='h4'>
						{t('drawerListItems.editPreAdmission')}
					</Typography>
					<Card sx={{ marginTop: 3 }}>
						<CardContent sx={{ padding: '24px' }}>
							<EditCaseStatusForm
								ref={caseStatusRef}
								type={type}
								setType={setType}
								details={details?.data}
							/>
						</CardContent>

						<CardActions sx={{ justifyContent: 'end', padding: '24px' }}>
							<Button
								onClick={() => {
									navigate(
										`/pre-admission/pre-admission-list/detail/${preAdmissionId}`
									);
								}}
								variant='text'
								sx={{ textTransform: 'none' }}
							>
								{t('button.cancel')}
							</Button>
							<Button
								type='submit'
								variant='contained'
								onClick={handleSubmit}
								sx={{ textTransform: 'none' }}
								endIcon={<CheckCircleOutlineIcon />}
							>
								{t('button.complete')}
							</Button>
						</CardActions>
					</Card>
				</Box>
			</Box>
		</>
	);
}
